import React, { useState, useEffect } from 'react';
import {Redirect } from 'react-router-dom';
import { useSelector} from 'react-redux';
import firebase from '../../config/firebase';
import "animate.css"
import './documentlist.css';

function DocumentsList({competencia, pdf, cpf, nome, tipo, year, id}){   

  const [urlPdf, setUrlPdf] = useState();
    useEffect(() => {
      firebase.storage().ref(`PDF/${pdf}`).getDownloadURL().then(url => setUrlPdf(url));
    }, [urlPdf]);
    return(
      <>
        {           
            useSelector(state => state.usuarioEmail) === "sistemadeltario@gmail.com" ?                  
        <>
            <div className="mt-4 file-div animate__animated animate__pulseIn">
              <div className="div-left">
                <p className="competencia">{tipo}</p>
                <p className="competencia">{nome}</p>
                <p className="competencia"><strong>Documento:</strong> <br/>{cpf}</p>
                <p className="competencia"><strong>Competência:</strong> {competencia}/{year}</p>
              </div>
              <a className="btn-down"href={urlPdf} target="_blank">Download</a>
              {/* <button className="remove-doc"><i className="bi bi-pencil-square"></i></button> */}
            </div>  
        </>
        :
        <>   
            <div className="mt-4 file-div animate__animated animate__pulseIn">
              <div className="div-left">
                <p className="competencia">{tipo}</p>
                <p className="competencia"><strong>Documento:</strong> {cpf}</p>
                <p className="competencia"><strong>Competência:</strong> {competencia}/{year}</p>
              </div>
              <a className="btn-down"href={urlPdf} target="_blank">Download</a>
            </div>
        </>        
        }  
      </>
    )
}

export default DocumentsList;